import { useEffect, useState } from "react";
import { Moon, Sun } from "lucide-react";

export function ThemeToggle({ className = "" }) {
  const [dark, setDark] = useState(true);

  useEffect(() => {
    const stored = localStorage.getItem("theme");
    const isDark = stored ? stored === "dark" : true;
    setDark(isDark);
    document.documentElement.classList.toggle("dark", isDark);
  }, []);

  const toggle = () => {
    const next = !dark;
    setDark(next);
    document.documentElement.classList.toggle("dark", next);
    localStorage.setItem("theme", next ? "dark" : "light");
  };

  return (
    <button
      onClick={toggle}
      data-testid="theme-toggle"
      className={`h-9 w-9 flex items-center justify-center border border-border hover:border-brand transition-colors ${className}`}
      aria-label="Cambiar tema"
    >
      {dark ? <Sun size={16} /> : <Moon size={16} />}
    </button>
  );
}
